<template>
    <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="首页组件管理" name="first">
                <app-component/>
            </el-tab-pane>
            <el-tab-pane label="APP首页金刚区管理" name="second">
                <king-kong/>
            </el-tab-pane>
            <el-tab-pane label="FOCUS首页金刚区管理" name="four">
                <king-kong/>
            </el-tab-pane>
            <el-tab-pane label="理财首页金刚区管理" name="five">
                <king-kong/>
            </el-tab-pane>
            <el-tab-pane label="理财首页" name="third">
                <manage-money/>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import AppComponent from './appComponent';
    import KingKong from './kingKong';
    import ManageMoney from './manageMoney';
    import "../store";
    import {mapActions, mapState} from "vuex";
    import {RIGHTS_TYPE} from "../../../common/constant";

    export default {
        name: "appHome",
        components: {ManageMoney, KingKong, AppComponent},
        comments: {AppComponent, KingKong, ManageMoney},
        data() {
            return {
                activeName: '',
            }
        },
        computed: {
            ...mapState(["userInfo", "userRights"]),
            ...mapState("PortalManage", ["appKingKongLang", "focusKingKongLang"])
        },
        created() {
            if (this.rightsContains('APP_COMPONENT')) {
                this.activeName = 'first';
                this.selectAppComponent();
            } else if (this.rightsContains('APP_KING_KONG')) {
                this.activeName = 'second';
                this.selectAreaType(1);
                this.selectKingKong({type: 1});
            } else if (this.rightsContains('FINANCIAL_MANAGEMENT')) {
                this.activeName = 'third';
                this.selectManageMoney();
            } else if (this.rightsContains('APP_KING_KONG')) {
                this.activeName = 'four';
                this.selectAreaType(2);
                this.selectKingKong({type: 2});
            } else if (this.rightsContains('APP_KING_KONG')) {
                this.activeName = 'five';
                this.selectAreaType(3);
                this.selectKingKong({type: 3});
            }
        },
        methods: {
            ...mapActions("PortalManage", ["selectAppComponent", "selectKingKong", 'selectManageMoney', 'selectAreaType']),
            handleClick(tab, event) {
                if (tab.name === 'first') {
                    this.selectAppComponent();
                    return;
                }
                if (tab.name === 'second') {
                    this.selectAreaType(1);
                    this.selectKingKong({type: 1, languageCode: this.appKingKongLang});
                    return;
                }
                if (tab.name === 'third') {
                    this.selectManageMoney();
                }
                if (tab.name === 'four') {
                    this.selectAreaType(2);
                    this.selectKingKong({type: 2, languageCode: this.focusKingKongLang});
                    return;
                }
                if (tab.name === 'five') {
                    this.selectAreaType(3);
                    this.selectKingKong({type: 3, languageCode: this.focusKingKongLang});
                    return;
                }

            },
            rightsContains(r) {
                let rights = this.userRights.split(",") || [];
                return rights.indexOf(RIGHTS_TYPE[r]) !== -1;
            },
        }
    }
</script>

<style scoped>

</style>
